const Button = {
  isComponent: el => {
    if (el.tagName === 'BUTTON') {
      return {
        type: 'button',
        tagName: 'button',
        draggable: 'form, form *'
      }
    }
    if (el.tagName === 'A' && el.classList.contains('button')) {
      return {
        type: 'button',
        tagName: 'a'
      }
    }
  },
  model: {
    defaults: Object.assign({}, {
      tagName: 'button',
      draggable: true,
      droppable: true,
      copyable: true,
      attributes: {
        id: 'button',
        'attr-size': 'default'
      },
      traits: [
        {
          name: 'id',
          label: 'ID',
          placeholder: 'ID',
          type: 'text'
        },
        {
          name: 'attr-size',
          label: 'Size',
          placeholder: 'Size',
          type: 'select',
          options: [
            'x-small',
            'small',
            'default',
            'large',
            'x-large'
          ]
        },
        {
          name: 'attr-outlined',
          label: 'Outlined',
          type: 'checkbox'
        },
        {
          name: 'attr-rounded',
          label: 'Rounded',
          type: 'checkbox'
        },
        {
          name: 'attr-block',
          label: 'Block',
          type: 'checkbox'
        }
      ]
    }),
    init() {
      const props = this.props()
      if (props.tagName === 'button') {
        this.addTrait({
          name: 'type',
          label: 'Type',
          placeholder: 'Type',
          type: 'select',
          options: [
            'button',
            'submit',
            'reset'
          ]
        }, { at: 1 })
      }
      if (props.tagName === 'a') {
        this.addTrait({
          type: 'text',
          name: 'href',
          label: 'href',
          placeholder: 'href'
        }, { at: 1 })
        this.addTrait({
          type: 'select',
          name: 'target',
          label: 'Target',
          placeholder: 'Target',
          options: [
            { id: '_self', name: 'This window'},
            { id: '_blank', name: 'New window'}
          ]
        }, { at: 2 })
      }
      const attributes = this.getAttributes()
      if (!attributes.target) {
        attributes.target = '_blank'
      }
      if (this.getClasses().includes('button--outlined')) {
        attributes['attr-outlined'] = true
      } else {
        attributes['attr-outlined'] = false
      }
      if (this.getClasses().includes('button--block')) {
        attributes['attr-block'] = true
      } else {
        attributes['attr-block'] = false
      }
      if (this.getClasses().includes('button--rounded')) {
        attributes['attr-rounded'] = true
      } else {
        attributes['attr-rounded'] = false
      }
      this.setAttributes(attributes)
      this.on('change:attributes:attr-size', this.handleSizeChange)
      this.on('change:attributes:attr-outlined', this.handleOutlinedChange)
      this.on('change:attributes:attr-rounded', this.handleRoundedChange)
      this.on('change:attributes:attr-block', this.handleBlockChange)
    },
    handleSizeChange() {
      const targetAttr = this.getAttributes()['attr-size']
      const targetClasses = this.getClasses()
      const removeClasses = targetClasses.filter(e => /size--(default|x-small|small|large|x-large)/g.test(e))
      if (removeClasses.length) {
        this.removeClass(removeClasses)
      }
      this.addClass(`size--${targetAttr}`)
    },
    handleStyleChange() {
      const targetAttr = this.getAttributes()['attr-style']
      const targetClasses = this.getClasses()
      const removeClasses = targetClasses.filter(e => /button--(default|icon|fab)/g.test(e))
      if (removeClasses.length) {
        this.removeClass(removeClasses)
      }
      if (targetAttr !== 'default') {
        this.addClass(`button--${targetAttr}`)
      }
    },
    handleOutlinedChange() {
      const targetAttr = this.getAttributes()['attr-outlined']
      if (targetAttr) {
        this.addClass('button--outlined')
      } else {
        this.removeClass('button--outlined')
      }
    },
    handleRoundedChange() {
      const targetAttr = this.getAttributes()['attr-rounded']
      if (targetAttr) {
        this.addClass('button--rounded')
      } else {
        this.removeClass('button--rounded')
      }
    },
    handleBlockChange() {
      const targetAttr = this.getAttributes()['attr-block']
      if (targetAttr) {
        this.addClass('button--block')
      } else {
        this.removeClass('button--block')
      }
    }
  }
}

export default Button
